import React, { Component } from "react";
import {
	// LineChart,
	BarChart,
	Bar,
	CartesianGrid,
	XAxis,
	YAxis,
	Tooltip,
	Legend,
	// Line,
	ResponsiveContainer
} from "recharts";
import moment from "moment";

import "./style.css";

const missedDates = [
	"2021-11-24",
	"2021-11-25",
	"2021-11-28",
	"2021-11-29",
	"2021-12-06",
	"2021-12-07"
];

const colors = [
	"",
	"#097D23", // Default color for all industries
	"#B55E8E",
	"#FF34FF",
	"#FF4A46",
	"#008941",
	"#006FA6",
	"#A30059",
	"#7A4900",
	"#0000A6",
	"#63FFAC",
	"#B79762",
	"#004D43",
	"#8FB0FF",
	"#997D87",
	"#5A0007",
	"#809693",
	"#1B4400",
	"#4FC601",
	"#3B5DFF",
	"#4A3B53",
	"#FF2F80",
	"#61615A",
	"#BA0900",
	"#6B7900",
	"#00C2A0",
	"#FFAA92",
	"#FF90C9",
	"#B903AA",
	"#D16100",
	"#DDEFFF",
	"#000035",
	"#7B4F4B",
	"#A1C299",
	"#300018",
	"#0AA6D8",
	"#013349",
	"#00846F",
	"#372101",
	"#FFB500",
	"#C2FFED",
	"#A079BF",
	"#CC0744",
	"#C0B9B2",
	"#C2FF99",
	"#001E09",
	"#00489C",
	"#6F0062",
	"#0CBD66",
	"#EEC3FF",
	"#456D75",
	"#B77B68",
	"#7A87A1",
	"#788D66",
	"#885578",
	"#FAD09F",
	"#FF8A9A",
	"#D157A0",
	"#BEC459",
	"#456648",
	"#0086ED",
	"#886F4C",
	"#34362D",
	"#B4A8BD",
	"#00A6AA",
	"#452C2C",
	"#636375",
	"#A3C8C9",
	"#FF913F",
	"#938A81",
	"#575329",
	"#00FECF",
	"#B05B6F",
	"#8CD0FF",
	"#3B9700",
	"#04F757",
	"#C8A1A1",
	"#1E6E00",
	"#7900D7",
	"#A77500",
	"#6367A9",
	"#A05837",
	"#6B002C",
	"#772600",
	"#D790FF",
	"#9B9700",
	"#549E79",
	"#FFF69F",
	"#201625",
	"#72418F",
	"#BC23FF",
	"#99ADC0",
	"#3A2465",
	"#922329",
	"#5B4534",
	"#FDE8DC",
	"#404E55",
	"#0089A3",
	"#CB7E98",
	"#A4E804",
	"#324E72",
	"#6A3A4C"
];

const manualColours = [
	'#8baf35',
	'#acd844',
	'#eadb49',
	'#f3a83c',
	'#ed662c',
	'#ec5729',
	'#ec4a27',
	'#eb3f25',
	'#eb3724',
	'#eb3223'
].reverse();

const stops = manualColours.map((color, index) => {
	const offset = index * 10;
	return <stop stopColor={color} offset={`${offset}%`} key={index} />;
});

class TickLabel extends Component {
	click = () => {
		const { index, data, onClick } = this.props;
		onClick(data[index].date);
	};

	render() {
		const { x, y, payload, index, data } = this.props;
		const { hasTweets } = data[index];

		return (
			<g transform={`translate(${x},${y})`}>
				<text x={0} y={0} dy={16} textAnchor="middle" fill="#666">
					{payload.value}
				</text>
				{hasTweets && (
					<image
						onClick={this.click}
						style={{ cursor: "pointer" }}
						x={-7}
						y={25}
						xlinkHref="img/cursor.svg"
					/>
				)}
			</g>
		);
	}
}

class Chart extends Component {


	render() {

		const { industries, data, onClick } = this.props;

		return (
			<div className="bl-graph">
				<ResponsiveContainer width="100%" height={450}>
					{/* <LineChart
						data={data}
						margin={{ top: 8, right: 16, left: 16, bottom: 16 }}
					>
						<CartesianGrid strokeDasharray="3 3" />
						<XAxis
							dataKey={e => {
								let dateLabel = moment(e.date, "YYYY-MM-DD").format("MMM Do");
								if (missedDates.includes(e.date)) {
									dateLabel = `${dateLabel}*`;
								}
								return dateLabel;
							}}
							tick={<TickLabel data={data} onClick={onClick} style={{ fill: "#252525", fontWeight: "bold" }} />}
						/>
						<YAxis
							type="number"
							domain={[0, 10]}
							ticks={[0, 2, 4, 6, 8, 10]}
							label={{
								value: "Local RankFlux Score",
								angle: -90,
								dy: 80,
								dx: -5,
								fontSize: 18,
								fontWeight: "bold",
								fill: "#252525",
								position: "insideLeft"
							}}
						/>
						<Tooltip />

						{industries
							.filter(e => e.selected)
							.map(industry => (
								<Line
									legendType="rect"
									type="linear"
									stroke={colors[industry.id]}
									strokeWidth={4}
									dot={true}
									activeDot={false}
									name={industry.name}
									dataKey={e => e.points[industry.id]}
									key={industry.id} // Added key prop for uniqueness
								/>
							))}

						<Line
							legendType="rect"
							type="linear"
							stroke="#1D2B3B"
							strokeWidth={4}
							dot={true}
							activeDot={false}
							name="All Industry Average"
							dataKey={e => e.points.avg}
							className="rf-gradient-line"
						/>
						<defs>
							<linearGradient
								x1="0%"
								y1="0%"
								x2="0%"
								y2="100%"
								id="linearGradient-1"
							>
								{stops}
							</linearGradient>
						</defs>
						<rect
							x={35}
							y={6}
							width="15"
							height="365"
							fill="url(#linearGradient-1)"
						/>
						<Legend
							verticalAlign="bottom"
							height={36}
							iconSize={11}
						/>
					</LineChart> */}

					<BarChart
						data={data}
						margin={{ top: 8, right: 16, left: 16, bottom: 16 }}
					>
						<CartesianGrid strokeDasharray="3 3" />
						<XAxis
							dataKey={(e) => {
								let dateLabel = moment(e.date, "YYYY-MM-DD").format("MMM Do");
								if (missedDates.includes(e.date)) {
									dateLabel = `${dateLabel}*`;
								}
								return dateLabel;
							}}
							tick={<TickLabel data={data} onClick={onClick} style={{ fill: "#252525", fontWeight: "bold" }} />}
						/>
						<YAxis
							type="number"
							domain={[0, 10]}
							ticks={[0, 2, 4, 6, 8, 10]}
							label={{
								value: "Local RankFlux Score",
								angle: -90,
								dy: 80,
								dx: -5,
								fontSize: 18,
								fontWeight: "bold",
								fill: "#252525",
								position: "insideLeft"
							}}
						/>
						<Tooltip />

						{industries
							.filter((e) => e.selected)
							.map((industry) => (
								<Bar
									legendType="rect"
									dataKey={(e) => e.points[industry.id]}
									fill={colors[industry.id]}
									name={industry.name}
									key={industry.id} // Ensure unique keys
								/>
							))}

						<Bar
							legendType="rect"
							dataKey={(e) => e.points.avg}
							fill="#097D23"
							name="All Industry Average"
						/>
						<defs>
							<linearGradient
								x1="0%"
								y1="0%"
								x2="0%"
								y2="100%"
								id="linearGradient-1"
							>
								{stops}
							</linearGradient>
						</defs>
						<rect
							x={35}
							y={6}
							width="15"
							height="365"
							fill="url(#linearGradient-1)"
						/>
						<Legend verticalAlign="bottom" height={36} iconSize={11} />
					</BarChart>



				</ResponsiveContainer>
				{data.some(item => missedDates.includes(item.date)) && <p>* denotes a day on which data was not collected accurately, so an average has been calculated</p>}
			</div>
		);
	}
}

export default Chart;
